<template>
  <div>
    <Select2
      class="default-style"
      :options="companiesOptions"
      @input="selectCompany"
      placeholder="Buscar empresa"
      :selectedOption="selectedCompany"
      :filterable="false"
      @search="searchCompanies">
    </Select2>
  </div>
</template>

<script>

import CompaniesService from '@/modules/companies/services/companies-service'

import Select2 from '@/components/common/Select/Select2'

export default {
  name: 'SelectCompanyInput',
  props: ['company', 'value'],
  components: {
    Select2
  },
  data () {
    return {
      companies: [],
      selectedCompany: '',
      throttleSearch: null
    }
  },
  created () {
  },
  computed: {
    /**
     * Company options
    */
    companiesOptions () {
      const processedIds = new Set()
      return this.companies
        .filter(company => !processedIds.has(company.id) && processedIds.add(company.id))
        .map(company => ({ label: `${company.name}`, code: company.id }))
    }
  },
  methods: {
    /**
     * Get companies
     */
    async getCompanies (searchTerm, loading) {
      try {
        const params = {
          search: searchTerm,
          page: 1,
          has_incomplete_data: 0
        }
        if (this.company) params.company_id = this.company.id
        const companies = await CompaniesService.getCompanies(params)
        this.companies = [...this.companies, ...companies.data]
        loading(false)
      } catch (error) {
        this.$emit('error', error)
      }
    },
    /**
     * Get companies for search
     */
    getCompaniesForSearch (searchTerm, loading) {
      this.companies = []
      this.page = 1
      this.getCompanies(searchTerm, loading)
    },
    /**
     * Handle select company
     */
    selectCompany (company) {
      this.$emit('input', company ? company.code : '')
    },
    /**
     * Search companies
     */
    searchCompanies ({ searchTerm, loading }) {
      clearTimeout(this.throttleSearch)
      this.throttleSearch = setTimeout(() => {
        this.getCompaniesForSearch(searchTerm, loading)
      }, 800)
    }
  }
}
</script>
